import React, { useState, useEffect } from "react";
import "./FilterModal.css";
import axios from "axios";
import Cookies from "js-cookie";
import api from "../chat/api";
const FilterModal = ({ isOpen, onClose, onApply, setFiles, setFolders,setIsFilterApplied,selectedFilters,setSelectedFilters }) => {
  const [token, setToken] = useState("");
  // const [selectedFilters, setSelectedFilters] = useState({
  //   folder: false,
  //   normalDocument: false,
  //   contract: false,
  //   invoice: false,
  // });
  const [fileType, setFileType] = useState([]);
  const [minSize, setMinSize] = useState("");
  const [maxSize, setMaxSize] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [rangeDate, setRangeDate] = useState("");
const [allTags, setAllTags] = useState([]);
const [selectedTags, setSelectedTags] = useState([]);
const [searchTag, setSearchTag] = useState("");




  const [activeTab, setActiveTab] = useState("FileType");


  const clearFilters = async () => {
    setSelectedFilters({
      folder: false,
      normalDocument: false,
      contract: false,
      invoice: false,
      spreadsheets:false,
    });
    setFileType([]);
    setFromDate("");
    setToDate("");
    setRangeDate("");

    try {
        // Fetch default files and folders without any filters
        const response = await api.get("api/v1/readpdf/files-and-folders/");


        if (response.status === 200) {
            const { files, folders } = response.data;

            setFiles(Array.isArray(files) ? files : []); // Ensure files is always an array
            setFolders(Array.isArray(folders) ? folders : []);
            setIsFilterApplied(false); // Ensure folders is always an array
        }
    } catch (error) {
        console.error("Error fetching default data:", error);
        setFiles([]); // Reset to empty array if fetch fails
        setFolders([]);
    } finally {
        onClose(); // Close modal after clearing
    }
};

  useEffect(() => {
  if (isOpen) {
    fetchTags();
  }
}, [isOpen]);

const fetchTags = async () => {
  try {
    const response = await api.get("/api/tagging/tags/");
    if (response.status === 200) {
      setAllTags(response.data);
    }
  } catch (error) {
    console.error("Failed to fetch tags:", error);
  }
};


const filteredTags = allTags.filter(tag =>
  tag.name.toLowerCase().includes(searchTag.toLowerCase())
);

const handleTagCheckboxChange = (tagId) => {
  setSelectedTags(prev =>
    prev.includes(tagId) ? prev.filter(id => id !== tagId) : [...prev, tagId]
  );
};


const handleApply = async () => {
  try {
    // Convert tag IDs to names
    const selectedTagNames = allTags
      .filter(tag => selectedTags.includes(tag.id))
      .map(tag => tag.name);

    const combinedFileTypesAndTags = [...fileType, ...selectedTagNames];

    const params = {
      file_type:
        combinedFileTypesAndTags.length > 0
          ? combinedFileTypesAndTags.join(",")
          : undefined,
      ...(rangeDate
        ? { date_range: rangeDate }
        : {
            from_date: fromDate || undefined,
            to_date: toDate || undefined,
          }),
    };

    const response = await api.get("api/v1/readpdf/filter-files-and-folders/", {
      params,
    });

    if (response.status === 200) {
      const filteredFiles = response.data.files.map((file) => ({
        ...file,
        pdf_url: file.url || file.pdf_url || "",
        document_type: file.type || "Unknown",
      }));

      const filteredFolders = response.data.folders.map((folder) => ({
        ...folder,
        file_type: "Folder",
        document_type: "folder",
        documents: folder.documents.map((doc) => ({
          ...doc,
          pdfUrl: doc.url || doc.file_url,
          pdfKey: doc.id,
        })),
      }));

      setFiles(filteredFiles || []);
      setFolders(filteredFolders || []);
      setIsFilterApplied(true);

      // Reset filters (optional)
      setFileType([]);
      setFromDate("");
      setToDate("");
      setRangeDate("");
    }
  } catch (err) {
    console.error("Error while applying filter:", err);
  }

  onClose();
};


  
  
  

  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    setRangeDate(value);
    const today = new Date();
    if (value === "today") {
      setFromDate(today.toISOString().split("T")[0]);
      setToDate(today.toISOString().split("T")[0]);
    } else if (value === "last7days") {
      const last7Days = new Date(today);
      last7Days.setDate(today.getDate() - 7);
      setFromDate(last7Days.toISOString().split("T")[0]);
      setToDate(today.toISOString().split("T")[0]);
    } else if (value === "thisyear") {
      const startOfYear = new Date(today.getFullYear(), 0, 1);
      setFromDate(startOfYear.toISOString().split("T")[0]);
      setToDate(today.toISOString().split("T")[0]);
    }
  };
  const handleCheckboxChange = (type) => {
    setSelectedFilters((prev) => {
      const updatedFilters = { ...prev, [type]: !prev[type] };
  
      setFileType(() => {
        const fileTypeMapping = {
          folder: "folder",
          normalDocument: "normal_document",
          contract: "contract",
          invoice: "invoice",
          spreadsheet: "spreadsheet",
        };
  
        return Object.keys(updatedFilters)
          .filter((key) => updatedFilters[key])
          .map((key) => fileTypeMapping[key]);
      });
  
      return updatedFilters;
    });
  };
  
  
  
  
  const safeToLowerCase = (str) => {
    return str && typeof str === 'string' ? str.toLowerCase() : ''; 
  };
  

  if (!isOpen) return null;

  return (
    <div className="filter-modal-overlay-doc">
      <div className="filter-modal-docs">
      <button className="close-button-folder" onClick={onClose}>&times;</button>
        <h2>Filter By</h2>
        <div className="Display">
          <div className="Box-rec">
           
            <button
              className={`Box-docs ${activeTab === "FileType" ? "active-tab" : ""}`}
              onClick={() => setActiveTab("FileType")}
            >
              <img src="./File-type.svg" alt="" />
              File Type
            </button>

            <button
  className={`Box-docs ${activeTab === "Tags" ? "active-tab" : ""}`}
  onClick={() => setActiveTab("Tags")}
>
  <img src="./tags-icon.svg" alt="" />
  Tags
</button>

           
          </div>
          {activeTab === "FileType" && (
            <div className="filter-options ml-2">
              <div className="Header-doc-filter-folder">
                <p>Choose which file types to show in results </p>
              </div>
              <label>
  <input
    type="checkbox"
    checked={selectedFilters.folder}
    onChange={() => handleCheckboxChange("folder")}
    className="chekcbox-doc-filter"
  />
  Folder
</label>
<label>
  <input
    type="checkbox"
    checked={selectedFilters.normalDocument}
    onChange={() => handleCheckboxChange("normalDocument")}
    className="chekcbox-doc-filter"
  />
  All Document
</label>
<label>
  <input
    type="checkbox"
    checked={selectedFilters.contract}
    onChange={() => handleCheckboxChange("contract")}
    className="chekcbox-doc-filter"
  />
  Contract
</label>
<label>
  <input
    type="checkbox"
    checked={selectedFilters.invoice}
    onChange={() => handleCheckboxChange("invoice")}
    className="chekcbox-doc-filter"
  />
  Invoice
</label>
<label>
  <input
    type="checkbox"
    checked={selectedFilters.spreadsheet}
    onChange={() => handleCheckboxChange("spreadsheet")}
    className="chekcbox-doc-filter"
  />
 Spreadsheet
</label>

             <div className="filter-actions-folder">
        <button onClick={clearFilters} className="filter-actions-folder-button">
  Clear All
</button>          <button onClick={handleApply}className="filter-actions-folder-buttons">Apply filter</button>
        </div>  
            
            </div>

          )}
                {activeTab === "Tags" && (
  <div className="filter-options ml-2">
    <div className="Header-doc-filter-folder">
      <p>Select Tags to include in the results</p>
    </div>
    <input
      type="text"
      placeholder="Search tags"
      value={searchTag}
      onChange={(e) => setSearchTag(e.target.value)}
      className="tag-search-input"
    />
    <div className="tag-scroll-container">
      {filteredTags.slice(0, 20).map((tag) => (
        <label key={tag.id} className="tag-checkbox-label ml-2">
        <input
  type="checkbox"
  className="custom-checkbox"
  style={{
    appearance: "none",
    border: "1.5px solid #c0c0c0",
    borderRadius: "4px",
    width: "16px",
    height: "16px",
    cursor: "pointer",
    backgroundImage: selectedTags.includes(tag.id) ? "url('/checck.svg')" : "none",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px 20px",
  }}
  onChange={() => handleTagCheckboxChange(tag.id)}
  checked={selectedTags.includes(tag.id)}
/>

          
          <span
            className="tag-color-dot"
            style={{ backgroundColor: tag.color }}
          ></span>
          {tag.name} 
        </label>
      ))}
    </div>
    <div className="filter-actions-folder">
      <button onClick={clearFilters} className="filter-actions-folder-button">
        Clear All
      </button>
      <button onClick={handleApply} className="filter-actions-folder-buttons">
        Apply filter
      </button>
    </div>
  </div>
)}

        </div>
     
      </div>




    </div>
  );
};

export default FilterModal;
